import useSWRQuery from 'data-hooks/useSWRQuery';
import isUnitTestEnv from 'commons/isUnitTestEnv';
import allActiveOptionValuesMockData from 'data-hooks/mocks/data/allActiveOptionValues.json';
import { GET_ALL_ACTIVE_OPTION_VALUES_RAW } from './queries';
import getFormattedOptions from './getFormattedOptions';
let cachedResponseData = isUnitTestEnv() ? allActiveOptionValuesMockData : null;
let cachedFormattedOptions = null;
const useAllOptions = (skip = false) => {
  const skipQuery = skip || !!cachedResponseData;
  const {
    data,
    isLoading,
    error
  } = useSWRQuery(!skipQuery ? GET_ALL_ACTIVE_OPTION_VALUES_RAW : null, {
    // These options disable client-side revalidation, so once this data has
    // been successfully loaded it will be reused until the page is refreshed.
    // If initial data is provided by the server via the "fallback" property
    // (which it normally should be) then that data will be used immediately
    // and the initial client-side request will be skipped.
    refreshInterval: 0,
    refreshWhenHidden: false,
    refreshWhenOffline: false,
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnMount: false,
    revalidateOnReconnect: false
  });

  // Since the "all options" data is not affected by location or user type, cache this
  // data for the lifetime of the browser session (until the page is refreshed)
  cachedResponseData = !cachedResponseData && !skip && !!data && !isLoading && !error ? data : cachedResponseData;
  cachedFormattedOptions = !cachedFormattedOptions && !skip && !!cachedResponseData ? getFormattedOptions({
    data: cachedResponseData,
    error,
    isLoading,
    skip
  }) : cachedFormattedOptions;
  if (skip || !cachedFormattedOptions) {
    return {
      isLoading: isLoading && !data?.allActiveOptionValues,
      error,
      allOptionsValues: null,
      allOptionsByValuesKey: null
    };
  }
  return cachedFormattedOptions;
};
export default useAllOptions;